// extracted by mini-css-extract-plugin
export default {"overlay":"IH-z","bodyOpen":"JH-z","content":"KH-z","header":"LH-z","close":"MH-z","closeNoHeading":"NH-z"};